import { SVGIconProps } from "@/interface/icon.types";
import React from "react";

const PlanaTriangleIcon = ({ className }: SVGIconProps) => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.5 19H2.43077L10.5 4.11539L18.5769 18.9777L20.5 19L10.5 1L0.5 19Z"
        fill="#334155"
      ></path>
      <path
        d="M10.4715 11.6364L14.2712 19H6.67185L10.4715 11.6364Z"
        fill="#334155"
      ></path>
    </svg>
  );
};

export default PlanaTriangleIcon;
